// extracted by mini-css-extract-plugin
export default {"wrapper":"RowHeader_wrapper__Ld7CW","item":"RowHeader_item__b0oql","ani":"RowHeader_ani__DHDgu"};